import BasePageStructure from 'src/components/BasePageStructure';
import styles from './Employees.module.css';
import { Box, Button, IconButton, Typography, CircularProgress } from '@mui/material';
import SearchBar from 'src/components/SearchBar';
import AppStripedDataGrid from 'src/components/AppStripedDataGrid';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useState } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { EmployeesService } from 'src/pehra-ts-client';
import { useQuery } from '@tanstack/react-query';
import NewEmployeesModal from './components/NewEmployeesModal';
import ConditionalRenderQuery from 'src/components/ConditionalRenderQuery';
import EmployeeTable from './components/EmployeeTable';
import { EmployeeState } from 'src/pehra-ts-client';

export interface IEmployees {}

const Employees: React.FC<IEmployees> = () => {
  const [searchText, setSearchText] = useState<string>('');
  const [openNewEmployeeModal, setOpenNewEmployeeModal] = useState<boolean>(false);
  const [employeeFilter, setEmployeeFilter] = useState<any>({
    state: EmployeeState.ACTIVE_IN_PRESENT_OFFICE
  });

  const handleSearchChange = (text: string) => {
    setSearchText(text);
  };

  const fetchEmployeesQuery = useQuery({
    queryKey: ['employeesList'],
    queryFn: () => EmployeesService.getAllEmployees(employeeFilter)
  });

  const handleRefresh = () => {
    fetchEmployeesQuery.refetch(); // Trigger a manual data refetch
  };

  const employeePositionComponent = (
    <Box className={styles.employeePositionContainer}>
      <Box className={styles.searchContainer}>
        <Box>{/* <SearchBar placeholder="Search Employees" searchText={searchText} handleSearchChange={handleSearchChange} /> */}</Box>
        <Box className={styles.actionContainer}>
          {/* <IconButton aria-label="refresh" onClick={handleRefresh}>
            <RefreshIcon />
          </IconButton> */}
          <IconButton aria-label="refresh" onClick={handleRefresh} disabled={fetchEmployeesQuery.isFetching}>
            {fetchEmployeesQuery.isFetching ? (
              <CircularProgress size={20} /> // Spinner while fetching
            ) : (
              <RefreshIcon />
            )}
          </IconButton>
          {/* <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              setOpenNewEmployeeModal(true);
            }}
          >
            Add New Employee
          </Button> */}
        </Box>
      </Box>
      <EmployeeTable rows={fetchEmployeesQuery.data?.employees} />
    </Box>
  );

  return (
    <BasePageStructure title="Employees">
      <Box className={styles.container}>
        <ConditionalRenderQuery
          status={fetchEmployeesQuery.status}
          // success={() => {
          //   return employeePositionComponent;
          // }}
          success={() => {
            return fetchEmployeesQuery.isFetching ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress />
              </Box>
            ) : (
              employeePositionComponent
            );
          }}
        />
      </Box>
      <NewEmployeesModal openModal={openNewEmployeeModal} handleCloseModal={() => setOpenNewEmployeeModal(false)} />
    </BasePageStructure>
  );
};

export default Employees;
